import Title from "./Title";
import { useState } from "react";

const FAQ_ITEMS = [
  {
    question: "How much does Takeoff cost?",
    answer: "Get started with Takeoff for only $6.99/month. Our pricing is designed to be accessible, with sponsored options available too."
  },
  {
    question: "Do you offer student discounts?",
    answer: "Yes! Takeoff is free for students and anyone who has graduated in the last year. Send proof of enrollment or graduation to <a href='mailto:info@takeoff.careers' style='text-decoration: underline; text-decoration-color: #eab308'>students@takeoff.careers</a> and we'll get you set up."
  },
  {
    question: "Can I use my own domain name?",
    answer: "Of course! It's super straightforward to connect your site to our domain. And if you don't have a domain, we can get you set up with one."
  },
  {
    question: "Do I need technical skills to use Takeoff?",
    answer: "Nope! Takeoff is a code-free portfolio editor."
  },
  {
    question: "How is Takeoff different from other website builders?",
    answer: "Takeoff focuses on what matters to jobseekers. You won't find any e-commerce or other business features, and that's intentional."
  },
  {
    question: "Can I cancel my subscription anytime?",
    answer: "Definitely! We offer a fully featured 30 day trial, and after that you can cancel anytime and we'll prorate your subscription."
  }
];

export default function FAQ() {
  const [activeIndices, setActiveIndices] = useState([]);

  const toggleFAQ = (index) => {
    setActiveIndices(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <section class="py-20" id="faq">
      <Title
        heading="Frequently Asked Questions"
        description="Got questions? We've got answers. If you don't see what you're looking for, reach out to our support team."
      />
      <div class="container mx-auto px-6 relative">
        <div class="max-w-3xl mx-auto content-card no-hover px-8 pt-4 pb-8">
          {FAQ_ITEMS.map((item, index) => (
            <div key={index} className={`faq-item ${activeIndices.includes(index) ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3 className="text-xl font-medium">{item.question}</h3>
                <button className="faq-toggle text-2xl">+</button>
              </div>
              <div className="faq-answer">
                <p dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
